module.exports = __webpack_public_path__ + "img/choose-account.ef120c51.png";